import { useTranslation } from 'react-i18next'
import { useFetcher } from 'react-router'
import { useOptionalUser } from '#app/utils/user.ts'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select.tsx'

function LanguageMenu() {
  const user = useOptionalUser()
  const { i18n } = useTranslation()
  const submitFetcher = useFetcher()

  const onValueChange = async (locale: string) => {
    await i18n.changeLanguage(locale)
    await submitFetcher.submit(
      {
        userId: user ? user.id : '',
        locale,
      },
      { method: 'POST', action: '/change-language' },
    )
  }

  const language = i18n.language
  const languageNames = new Intl.DisplayNames(language, { type: 'language' })
  const languageName = languageNames.of(language)

  return (
    <Select value={language} onValueChange={onValueChange}>
      <SelectTrigger aria-label={languageName}>
        <SelectValue placeholder="Language" />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="es">Español</SelectItem>
      </SelectContent>
    </Select>
  )
}

export { LanguageMenu }
